import { clsx } from 'clsx';
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { get } from '../constants.js';
import sx from '../sx.js';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.js';
import { defaultSxProp } from '../utils/defaultSxProp.js';
import '../FeatureFlags/FeatureFlags.js';
import { useFeatureFlag } from '../FeatureFlags/useFeatureFlag.js';
import '../FeatureFlags/DefaultFeatureFlags.js';
import Box from '../Box/Box.js';
import classes from './CounterLabel.module.css.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CounterLabel = /*#__PURE__*/forwardRef(({
  scheme = 'secondary',
  sx = defaultSxProp,
  className,
  children,
  ...rest
}, forwardedRef) => {
  const enabled = useFeatureFlag('primer_react_css_modules_team');
  const label = /*#__PURE__*/React.createElement(VisuallyHidden, null, "\xA0(", children, ")");
  const counterProps = {
    ref: forwardedRef,
    ['aria-hidden']: 'true',
    ['data-scheme']: scheme,
    ...rest
  };
  if (enabled) {
    if (sx !== defaultSxProp) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, _extends({
        as: "span"
      }, counterProps, {
        className: clsx(className, classes.CounterLabel),
        sx: sx
      }), children), label);
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", _extends({}, counterProps, {
      className: clsx(className, classes.CounterLabel)
    }), children), label);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledCounterLabel, _extends({}, counterProps, {
    className: className,
    sx: sx
  }), children), label);
});
const StyledCounterLabel = styled.span.withConfig({
  displayName: "CounterLabel__StyledCounterLabel",
  componentId: "sc-17qlupj-0"
})(["display:inline-block;padding:var(--base-size-2,0.125rem) var(--base-size-6,0.375rem);font-size:12px;font-weight:var(--base-text-weight-semibold,bold);line-height:1;border-radius:20px;border:var(--borderWidth-thin,max(1px,0.0625rem)) solid var(--counter-borderColor,var(--color-counter-border));&[data-scheme='primary']{background-color:", ";color:", ";}&[data-scheme='secondary']{background-color:", ";color:", ";}&:empty{display:none;}", ""], get('colors.neutral.emphasis'), get('colors.fg.onEmphasis'), get('colors.neutral.muted'), get('colors.fg.default'), sx);
CounterLabel.displayName = 'CounterLabel';

export { CounterLabel as default };
